import { Component, OnInit, OnDestroy  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { RoleService } from '../../services/role.service';
import { SubsidiaryService } from '../../services/subsidiary.service';

@Component({
    selector: 'app-update-role',
    templateUrl: './update-role.component.html',
    styleUrls: ['./update-role.component.css', '../../app.component.css']
})

export class UpdateRoleComponent implements OnInit, OnDestroy {

    roleForm: FormGroup;
    role: any = [];

    subsidiaries = {};
    subsidiaryInit: any;
    subsidiaryText = '';

    id: string;

    grSubs: any;
    gsSubs: any;
    gssSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private roleService: RoleService,
                private subsidiaryService: SubsidiaryService) {
        this.loadSubsidiaries();

        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.grSubs = this.roleService.getRole(this.id).subscribe(roleObj => {
                this.grSubs.unsubscribe();

                this.role = roleObj;

                this.gsSubs = this.subsidiaryService.getSubsidiary(this.role.subsidiaryId).subscribe(subsidiaryObj => {
                    this.gsSubs.unsubscribe();

                    this.subsidiaryText = subsidiaryObj.name;
                });
            });

            
        });
    }

    ngOnInit() {
        this.roleForm = this.formBuilder.group({
            name: ['', Validators.required],
            description: ['', Validators.required],
            subsidiary: ['', Validators.required]
        });
    }

    onSubmitRole() {
        this.role = this.saveRole();

        this.roleService.putRole(this.role, this.id).then(res => {
            this.router.navigate(['/roles_jobs', {outlets: {'tab_role': ['roles']}}]);
        });
    }

    saveRole() {
        const roleJson = {
            description: this.roleForm.get('description').value,
            name: this.roleForm.get('name').value,
            subsidiaryId: this.subsidiaries[this.roleForm.get('subsidiary').value],
            updatedAt: new Date()
        };

        return roleJson;
    }

    loadSubsidiaries() {
        this.gssSubs = this.subsidiaryService.getSubsidiaries().subscribe(tempSubsidiaries => {
            const data = {};

            for (const idx in tempSubsidiaries) {
                data[tempSubsidiaries[idx].name] = null;

                this.subsidiaries[tempSubsidiaries[idx].name] = tempSubsidiaries[idx].id$;
            }

            this.subsidiaryInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.subsidiaries[val]);
                }
            };
        });
    }

    onBlurSubsidiary() {
        if (this.subsidiaries[this.subsidiaryText] === undefined) {
            this.subsidiaryText = '';
        }
    }

    ngOnDestroy() {
        this.gssSubs.unsubscribe();
    }

}

